import { defHttp } from "../utils/http/axios";

const Api = {
    getMTDetail: "/cat/mt/detail/",
    getEngines: "/cat/mt/list/",
    getConfigs: "/cat/mt/config/list/",
    updateConfig: "/cat/mt/update/",
    saveConfig: "/cat/mt/save/",
    testQuery: "/cat/mt/test/",
    matchMT: "/cat/mt/match/",
};

/**
 * 得到机器翻译引擎具体信息
 * @param params
 * @returns {Promise<*>}
 */
export function getMTDetail(params) {
    return defHttp.get({ url: Api.getMTDetail, params }, { isTransformResponse: false });
}

/**
 * 获取机翻服务提供商
 * @returns
 */
export function getEngines(params) {
    return defHttp.get({ url: Api.getEngines, params });
}

/**
 * 获取机翻配置列表
 * @returns
 */
export function getConfigs() {
    return defHttp.get({ url: Api.getConfigs });
}

/**
 * 更新机翻配置
 * @param {*} data
 * @returns
 */
export function updateConfig(data) {
    return defHttp.post({ url: Api.updateConfig, data });
}

/**
 * 保存机翻配置
 * @returns
 */
export function saveConfig(data) {
    return defHttp.post({ url: Api.saveConfig, data });
}

/**
 * 测试机器翻译
 * @param {*} id
 * @returns
 */
export function testQuery(id) {
    return defHttp.get({ url: Api.testQuery, params: { id } });
}


/**
 * 2 分钟超时，与 saipan 后台翻译任务的等待超时设置一致。
 * 增加 10 秒钟缓冲时间，以考虑网络延迟、后台处理、消息队列处理...
 * @type {number}
 */
const AI_TRANSLATION_TIME_OUT = 2 * 60 * 1000 + 10 * 1000;
/**
 * 机器翻译
 * @param {*} data
 * @returns
 */
export function matchMT(data) {
    return defHttp.postWithCancel({ url: Api.matchMT, data, timeout: AI_TRANSLATION_TIME_OUT })
}
